// extracted by mini-css-extract-plugin
export var container = "styles-module--container--McJL-";
export var heading = "styles-module--heading--2d3ZI";
export var list = "styles-module--list--N5glY";